// custom typefaces
import 'typeface-montserrat';
import 'typeface-merriweather';
require('prismjs/themes/prism-okaidia.css');
// require("prism-themes/themes/prism-atom-dark.css")
// require('prismjs/plugins/line-numbers/prism-line-numbers.css');
require('./src/components/layout.css');
